
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Dropdown, Form, Row, Tab, Tabs } from "react-bootstrap";
import { GetPageByName, PostPage, UploadFile } from "api/endpoints";

import { FloatingLabel, } from "react-bootstrap";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { toast } from "react-toastify";
import MEICKEditor from "components/ckeditor/MEICKEditor";
import { FiUpload } from "react-icons/fi";
import MEILoader from "components/ckeditor/MEILoader";
import FilePreviewer from "components/ckeditor/MEIFilePreview";





const schema = yup
    .object({
        pTitle: yup.string(),
        pFeatured: yup.bool(),
        fFile: yup.string(),
        fDescription: yup.string(),
        metaDescription: yup.string(),
        metaTags: yup.string(),
        url: yup.string(),
        pName: yup.string(),
        pID: yup.string(),
        fStatus: yup.string().required("Status is required."),

    })
    .required();

const initialForm = {
    pTitle: '',
    pFeatured: false,
    fFile: '',
    fDescription: '',
    metaDescription: '',
    metaTags: '',
    url: '',
    pName: '',
    pID: '',
    fStatus: 'true',

};


const SettingsForm = ({ setLoading }) => {


    const {
        register,
        formState: { errors },
        getValues,
        setValue,
        watch
    } = useFormContext();


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {

            const allowedTypes = [
                'image/jpeg', // .jpg, .jpeg
                'image/gif',  // .gif
                'image/png',  // .png
                'video/mp4' // .mp4
            ];
            if (!allowedTypes.includes(file.type)) {
                toast.error('Invalid File Format', {
                    theme: "colored",
                });
                e.target.value = '';
                return
            }
            else {
                setLoading(true)
                const formData = new FormData();
                formData.append('file', file);

                UploadFile(formData).then(res => {
                    // toast.success('File Uploaded Successfully!', {
                    //   theme: "colored",
                    // });
                    setValue('fFile', res?.data)
                    e.target.value = '';
                    setLoading(false)
                }).catch(err => {
                    setLoading(false)
                    toast.error('File Uploading Failed', {
                        theme: "colored",
                    });
                });
            }

        }
    };


    return (
        <>

            <Row className="gx-2 gy-3 pt-2">

                <Col md="10">
                    <Form.Group>
                        <FloatingLabel
                            controlId="floatingInput"
                            label='Scope Name'
                            className=""
                        >
                            <Form.Control
                                type="text"
                                placeholder=""
                                isInvalid={!!errors.pTitle}
                                {...register("pTitle")}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors?.pTitle?.message}
                            </Form.Control.Feedback>
                        </FloatingLabel>
                    </Form.Group>
                </Col>
                <Col md="2" className="d-flex flex-column justify-content-center" >
                    <Form.Group>
                        <Form.Check
                            type="checkbox"
                            placeholder=""
                            isInvalid={!!errors.pFeatured}
                            {...register("pFeatured")}
                            label='Is Featured'
                        />
                    </Form.Group>
                </Col>


                <Col md="12" style={{ position: 'relative' }}>
                    {/* <Form.Group>
                        <FloatingLabel
                            controlId="floatingInput"
                            label="Scope Media"
                            className=""
                        >
                            <Form.Control
                                type="text"
                                placeholder=""
                                isInvalid={!!errors.fFile}
                                // style={{height: '80px'}}
                                {...register("fFile")}
                                onKeyDown={e => e.preventDefault()}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.fFile?.message}
                            </Form.Control.Feedback>
                        </FloatingLabel>
                    </Form.Group> */}

                    <Form.Label style={{ left: 10, position: 'absolute', top: 0 }}>
                        Scope Media (250 x 250)
                    </Form.Label>
                    <FilePreviewer accept=".jpg, .jpeg, .gif, .png, .mp4" furl={watch('fFile')} />


                    <Form.Label htmlFor={`file-upload-sc`} style={{ position: 'absolute', zIndex: 99, right: 20, top: '20%', cursor: 'pointer', textDecoration: 'underline' }} className="text-info">
                        <FiUpload className="me-1" size={40} />
                    </Form.Label>
                    <Form.Control
                        id={`file-upload-sc`}
                        type="file"
                        style={{ width: '120px' }}
                        onChange={(e) => handleFileChange(e)}
                        className="d-none"
                        accept=".jpg, .jpeg, .gif, .png, .mp4"
                    />

                </Col>



                <Col md="12">
                    <Form.Label>Page Content</Form.Label>
                    <MEICKEditor
                        value={getValues('fDescription')}
                        onchangeValue={(vl) => {
                            setValue('fDescription', vl)
                        }} />

                </Col>


                <Col md="6">
                    <Form.Group>
                        <FloatingLabel
                            controlId="floatingInput"
                            label="Meta Description"
                            className=""
                        >
                            <Form.Control
                                as="textarea"
                                rows={4}
                                placeholder=""
                                isInvalid={!!errors.metaDescription}

                                style={{ height: '120px' }}
                                {...register("metaDescription")}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.metaDescription?.message}
                            </Form.Control.Feedback>
                        </FloatingLabel>
                    </Form.Group>
                </Col>

                <Col md="6">
                    <Form.Group>
                        <FloatingLabel
                            controlId="floatingInput"
                            label="Meta Tags"
                            className=""
                        >
                            <Form.Control
                                as="textarea"
                                rows={4}
                                placeholder=""
                                isInvalid={!!errors.metaTags}

                                style={{ height: '120px' }}
                                {...register("metaTags")}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.metaTags?.message}
                            </Form.Control.Feedback>
                        </FloatingLabel>
                    </Form.Group>
                </Col>


                <Col md="4">
                    <Form.Group>
                        <FloatingLabel controlId="floatingInput" label="Status" className="">
                            <Form.Control
                                as="select"
                                placeholder=""
                                isInvalid={!!errors.fStatus}
                                {...register("fStatus")}
                            >
                                <option value="true">Published</option>
                                <option value="false">Un-Published</option>

                            </Form.Control>
                            <Form.Control.Feedback type="invalid">
                                {errors.fStatus?.message}
                            </Form.Control.Feedback>
                        </FloatingLabel>
                    </Form.Group>
                </Col>

            </Row>
        </>
    );
};





const AddScope = ({ handleDiscard, editData }) => {
    const methods = useForm({
        resolver: yupResolver(schema),
        defaultValues: {},
    });
    const { handleSubmit, reset } = methods;


    const onSubmit = (data) => {
        console.log(data);
        setLoading(true)
        const finalData = {
            id: editData?.id ? editData?.id : 0,
            heading: data.pTitle,
            isFeatured: data.pFeatured,
            backgroundImage: data.fFile,
            pageName: data.pName || data.pTitle,
            pageContent: data.fDescription,
            pageUrl: data.url || `/${data.pTitle.replaceAll(' ', '-').toLowerCase()}`,
            metaInfo: data.metaDescription,
            footer: data.metaTags,
            sortOrder: 0,
            status: data.fStatus === "true",
            pageType: 'SCOPE'
        }

        PostPage(finalData).then(res => {

            toast.success('Scope saved Successfully', {
                theme: "colored",
            });
            setLoading(false)
            reset(initialForm)
            handleDiscard(true);

        }).catch(err => {

            toast.error('Scope saving Failed', {
                theme: "colored",
            });
            setLoading(false)
            console.log(err, 'PostDownloadsError')

        });




    };

    const [loading, setLoading] = useState(false);


    useEffect(() => {
        if (editData?.id) {
            reset({
                pTitle: editData?.heading,
                pFeatured: editData?.isFeatured,
                fFile: editData?.backgroundImage,
                fDescription: editData?.pageContent,
                metaDescription: editData?.metaInfo,
                metaTags: editData?.footer,
                url: editData?.pageUrl,
                pName: editData?.pageName,
                fStatus: editData.status.toString(),
                pID: editData?.id,
            })
        }
        else {
            reset(initialForm)
        }

    }, [editData]);



    const handleDiscardPre = () => {
        reset(initialForm)
        handleDiscard();
    }



    return (
        <>

            <MEILoader showLoader={loading} />

            <FormProvider {...methods}>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row className="g-3">
                        <Col lg={12}>
                            <SettingsForm setLoading={setLoading} />
                        </Col>
                        <Col xs={12}>
                            <Row className="flex-between-center mt-3">
                                <Col md>
                                    {/* <h5 className="mb-2 mb-md-0">You're almost done</h5> */}
                                </Col>
                                <Col xs="auto">
                                    <Button
                                        variant="link"
                                        className="text-secondary fw-medium p-0 me-3"
                                        type="button"
                                        onClick={handleDiscardPre}
                                    >
                                        Discard
                                    </Button>
                                    <Button variant="primary" type="submit" disabled={loading}>
                                        {editData?.id ? 'Update' : 'Add'}
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form>
            </FormProvider>
        </>
    );
};

export default AddScope;
